export const CheckCart = (cartID) => {
    return `query {
    cart ( id : "${cartID}") {
        id
        lines(first: 100) {
            edges {
              node {
                id
              }
            }
        }
    }
}`;
}